import React, {Fragment} from 'react';
import {getPercentageFromTotal} from '../../../util/helpers';
import './estilos.css';

const degradeColors = ['#3d2ff6', '#3bdaaf', '#64da3b', '#dead1a', '#da983b', '#3bb0da', '#f6842f',
    '#3d2ff6', '#3bdaaf', '#64da3b', '#dead1a', '#da983b', '#3bb0da', '#f6842f',
    '#3d2ff6', '#3bdaaf', '#64da3b', '#dead1a', '#da983b', '#3bb0da', '#f6842f',
    '#3d2ff6', '#3bdaaf', '#64da3b', '#dead1a', '#da983b', '#3bb0da', '#f6842f',
    '#3d2ff6', '#3bdaaf', '#64da3b', '#dead1a', '#da983b', '#3bb0da', '#f6842f'
]

class GenericTable extends React.Component {

    campoExibePorcentagem = (campo) => {
        const camposSemPorcentagem = [
            'tx_pessoas_domicilios', 'area_km2', 'nr_densidade_demografica_hab_km2',
            'pib_per_capita', 'pib',
        ];
        return !camposSemPorcentagem.includes(campo);
    }

    camposComReferenciaaCidade = ['renda_media_domiciliar', 'nr_salario_minimo_mensal_por_domicilio'];

    constructor(props) {
        super(props);
        this.state = {
            data: [],
            headers: [],
            config: {
                dados: {},
                title: '',
                data_label: ''
            },
            downloading: false
        }
    }

    static getDerivedStateFromProps(props, state) {
        const dataFormatter = props.formatter;
        return {
            data: dataFormatter?.dataCollection,
            headers: dataFormatter?.headers,
            config: dataFormatter?.config,
        }
    }

    formatNumber = (number, precision = null) => {
        if (!precision) precision = 0;
        return new Intl.NumberFormat('pt-BR', {
            maximumFractionDigits: precision,
            minimumFractionDigits: precision
        }).format(Number(number));
    }

    exportExcel = async () => {
        try {
            this.setState({ downloading: true });
            const extra = await this.props.getExtraExportData?.() || {};
            const payload = this.getExportFilePayload(extra);
            const response = await axios.post(route('web.export.dados.sociodemografia'), payload, {
                responseType: 'blob'
            });
            const blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
            const fileName = response.headers['content-disposition'].split('filename=')[1];
            this.downloadBlob(blob, fileName);
        } catch (e) {
            console.log(e);
        } finally {
            this.setState({ downloading: false });
        }
    }

    getExportFilePayload(extra = {}) {
        const dadosKeys = Object.keys(this.state.config?.dados);
        const collectionKeys = Object.keys(this.state.data);
        const { extraData = {}, extraHeaders = [], extraKeys = [] } = extra;
        return {
            config: this.state.config,
            headers: [...this.state.headers, ...extraHeaders],
            dadosKeys,
            collectionKeys: [...collectionKeys, ...extraKeys],
            data: { ...this.state.data, ...extraData }
        };
    }

    exportPDF = async () => {
        try {
            this.setState({ downloading: true });
            const payload = this.getExportFilePayload();
            const response = await axios.post(route('web.export_pdf.dados.sociodemografia'), payload, {
                responseType: 'blob'
            });
            const blob = new Blob([response.data], { type: 'application/pdf' });
            const fileName = response.headers['content-disposition'].split('filename=')[1].replace(/"/g, '');
            this.downloadBlob(blob, fileName);
        } catch (e) {
            console.log(e);
        } finally {
            this.setState({ downloading: false });
        }
    }

    downloadBlob = (blob, filename) => {
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = filename;
        a.click();
        window.URL.revokeObjectURL(url);
    }

    getTotalCollumKey = (collectionKey) => {
        if (this.state.config?.datalayerName === 'populacao' || this.state.config?.datalayerName === 'domicilios') {
            const populacaoKeys = [
                'nr_pessoas_2022_v0001', 'nr_pessoas_proj_2025',
                'nr_populacao_0_4_anos_v01031', 'nr_populacao_5_9_anos_v01032',
                'nr_populacao_10_14_anos_v01033', 'nr_populacao_15_19_anos_v01034',
                'nr_populacao_20_24_anos_v01035', 'nr_populacao_25_29_anos_v01036',
                'nr_populacao_30_39_anos_v01037', 'nr_populacao_40_49_anos_v01038',
                'nr_populacao_50_59_anos_v01039', 'nr_populacao_60_69_anos_v01040',
                'nr_populacao_70_anos_mais_v01041', 'area_km2', 'nr_densidade_demografica_hab_km2',
            ];
            if (populacaoKeys.includes(collectionKey)) return 'nr_pessoas_2022_v0001';
            return 'nr_domicilios_particulares_v0003';
        }
        return 'total';
    }

    render() {
        const dadosKeys = Object.keys(this.state.config?.dados);
        const collectionKeys = Object.keys(this.state.data);

        return (
            <div className="card card-results" id="table-sociodemografia-resultados" style={{ height: 'auto' }}>
                <div>
                    <table className="table table-condensed">
                        <thead>
                            <tr>
                                <td colSpan={this.state.config.hide_percentage
                                    ? 1 + this.state.headers.length
                                    : 2 + (this.state.headers.length * 2)}>
                                    {this.state?.config?.title?.toUpperCase()}
                                </td>
                            </tr>
                            <tr>
                                <th rowSpan={2} scope="col">
                                    {this.state.config?.data_label}
                                </th>
                                {this.state.headers.map((header, index) => (
                                    <th key={`header-${index}`}
                                        colSpan={this.state.config.hide_percentage ? 1 : 2}
                                        scope="col"
                                        className="text-center">
                                        {header}
                                    </th>
                                ))}
                            </tr>
                            {this.state.config.uses_subheader && (
                                <tr>
                                    {this.state.headers.map((header, index) => (
                                        <Fragment key={`subheader-${header}-${index}`}>
                                            <th className="text-center">Absoluto</th>
                                            {!this.state.config.hide_percentage && (
                                                <th className="text-center">Percentual</th>
                                            )}
                                        </Fragment>
                                    ))}
                                </tr>
                            )}
                        </thead>
                        <tbody>
                            {dadosKeys.map((key, index) => (
                                <Fragment key={`row-${key}-${index}`}>
                                    <tr>
                                        <td>{this.state.config?.dados?.[key]}</td>

                                        {collectionKeys.map((collectionKey, indexTwo) => {
                                            const keyTotal = this.getTotalCollumKey(key);
                                            let total = this.state.data[collectionKey]?.items[0]?.[keyTotal];

                                            if (key === 'tx_indice_propriedade') total = 100;

                                            if (this.camposComReferenciaaCidade.includes(key)) {
                                                const cityNomes = this.state.config?.cityNomes ?? [];
                                                const firstCityKey = collectionKeys.find(k => cityNomes.includes(k));
                                                total = firstCityKey
                                                    ? this.state.data[firstCityKey]?.items?.[0]?.[key]
                                                    : undefined;
                                            }

                                            if (this.state.config.total_from_rows) {
                                                total = dadosKeys.reduce((sum, k) => sum + (Number(this.state.data[collectionKey]?.items?.[0]?.[k]) || 0), 0);
                                            }

                                            const porcentagem = getPercentageFromTotal(
                                                total,
                                                this.state.data[collectionKey]?.items[0]?.[key]
                                            );

                                            const gradienteColor = degradeColors[indexTwo];

                                            return (
                                                <Fragment key={collectionKey}>
                                                    <td className="td-absoluto">
                                                        {key !== 'tx_indice_propriedade' && key !== 'tx_pessoas_domicilios' && (
                                                            this.state.data[collectionKey]?.items?.[0]?.[key] == null
                                                                ? '–'
                                                                : this.formatNumber(
                                                                    this.state.data[collectionKey]?.items?.[0]?.[key],
                                                                    key === 'nr_salario_minimo_mensal_por_domicilio' ? 2 : 0
                                                                )
                                                        )}
                                                        {key === 'tx_pessoas_domicilios' && (
                                                            this.state.data[collectionKey]?.items?.[0]?.[key] == null
                                                                ? '–'
                                                                : this.formatNumber(this.state.data[collectionKey]?.items?.[0]?.[key], 2)
                                                        )}
                                                    </td>
                                                    {!this.state.config.hide_percentage && (
                                                        <td className="td-percentual" style={{
                                                            backgroundImage: `linear-gradient(to right, ${gradienteColor}22, transparent)`,
                                                            backgroundRepeat: 'no-repeat',
                                                            backgroundSize: `${porcentagem}% 100%`,
                                                        }}>
                                                            <div className="pg">
                                                                {this.campoExibePorcentagem(key)
                                                                    ? <span>{this.formatNumber(porcentagem, 1)}%</span>
                                                                    : <span>–</span>
                                                                }
                                                            </div>
                                                        </td>
                                                    )}
                                                </Fragment>
                                            );
                                        })}
                                    </tr>
                                </Fragment>
                            ))}
                        </tbody>
                        {!this.state.config.datalayerName && (
                            <tfoot>
                                <tr>
                                    <td>TOTAL</td>
                                    {collectionKeys.map((collectionKey) => (
                                        <Fragment key={collectionKey}>
                                            <td className="td-absoluto">
                                                {this.state.config.total_from_rows
                                                    ? this.formatNumber(dadosKeys.reduce((sum, key) => sum + (Number(this.state.data[collectionKey]?.items?.[0]?.[key]) || 0), 0))
                                                    : this.formatNumber(this.state.data[collectionKey]?.items?.[0]?.['total'])}
                                            </td>
                                            {!this.state.config.hide_percentage && (
                                                <td className="td-percentual">100%</td>
                                            )}
                                        </Fragment>
                                    ))}
                                </tr>
                                {(this.state.config.footer_fields || []).map((field) => (
                                    <tr key={field.key}>
                                        <td>{field.label}</td>
                                        {collectionKeys.map((collectionKey) => (
                                            <Fragment key={collectionKey}>
                                                <td className="td-absoluto" colSpan={!this.state.config.hide_percentage ? 2 : 1}>
                                                    {field.format === 'currency'
                                                        ? `R$ ${this.formatNumber(this.state.data[collectionKey]?.items?.[0]?.[field.key])}`
                                                        : this.formatNumber(this.state.data[collectionKey]?.items?.[0]?.[field.key])}
                                                </td>
                                            </Fragment>
                                        ))}
                                    </tr>
                                ))}
                            </tfoot>
                        )}
                    </table>

                    {this.state.config.more_info && (
                        <div className="alert alert-info">
                            <i className="fas fa-info-circle" /> &nbsp;
                            {this.state.config.more_info}
                        </div>
                    )}
                </div>

                <div className="sdp-export-actions">
                    <button className="btn btn-outline-secondary btn-sm" onClick={this.exportExcel}>
                        <i className="fas fa-file-excel" /> Excel
                        {this.state.downloading && <i className="fas fa-spinner fa-spin ml-1" />}
                    </button>
                    <button className="btn btn-outline-secondary btn-sm" onClick={this.exportPDF}>
                        <i className="fas fa-file-pdf" /> PDF
                        {this.state.downloading && <i className="fas fa-spinner fa-spin ml-1" />}
                    </button>
                </div>
            </div>
        );
    }
}

export default GenericTable;
